import DefaultController from './../../controller';

class Controller extends DefaultController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);
        this.type = 'linearGradient'; 

    }

}


let Blueprint = {
    type: Controller,
    properties: { 
        attributes: {
            'gradientUnits': 'userSpaceOnUse'
        }
     },
    children: [  ]
}

export default Blueprint;
export {Controller, Blueprint};